const _temp0 = require("../component-library/form/form-custom-select-script.js");
const _temp1 = require("../component-library/form/gform-script.js");

const _temp2 = require("../component-library/inline-svg/inline-svg-script.js");

const _temp3 = require("../component-library/media/media-script.js");

const _temp4 = require("../component-library/menu/menu-script.js");

const _temp5 = require("../component-library/parallax-container/parallax-container-script.js");

const _temp6 = require("../component-library/slider/slider-script.js");

module.exports = {
  "form":   {
    "form-custom-select-": _temp0,
    "gform-": _temp1
  },
  "inline-svg":   {
    "inline-svg-": _temp2
  },
  "media":   {
    "media-": _temp3
  },
  "menu":   {
    "menu-": _temp4
  },
  "parallax-container":   {
    "parallax-container-": _temp5
  },
  "slider":   {
    "slider-": _temp6
  }
}